import React from 'react';
import { CtaButton } from './CtaButton';
import { OFFER_ANCHOR } from '../../data/content';
interface CtaBlockProps {
  label?: string;
  note?: string;
  href?: string;
  dark?: boolean;
}
export function CtaBlock({
  label = '🚀 Sí, quiero comenzar ahora',
  note = 'Acceso Inmediato • Garantía de 7 Días',
  href = OFFER_ANCHOR,
  dark = false
}: CtaBlockProps) {
  return <div className="mx-auto mt-3 max-w-md text-center" data-id="element-157" data-mp="j54d6y2xnxo6">
      <CtaButton href={href} data-id="element-158" data-mp="j4kwfkp0rfbq">{label}</CtaButton>
      {note && <p className={`mt-1 text-xs font-medium ${dark ? 'text-white/80' : 'text-negro/70'}`} data-id="element-159" data-mp="e5rt2l3g54pa">{note}</p>}
    </div>;
}